import { FlowTrackerConfirmationSteps } from 'common/constants';
import { ATBeaconButton } from 'components/common/beacon/beaconRegistration';
import FlowTracker from 'components/common/FlowTracker/FlowTracker';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FooterSlot } from 'src/features/transfer/components/StepFooter/StepFooter';
import { RootState } from 'src/state/store';
import { dispatchPageLoad } from 'utils/analyticsUtil';
import { CTAVariants } from '@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant';
import '../DocusignReturn.scss';

interface DocusignConfirmation {
  confirmationNumber: string | null;
  processType: string | null;
}

const DocusignConfirmation: React.FC<DocusignConfirmation> = ({
  confirmationNumber,
  processType,
}) => {
  const cancelUrl = useSelector((state: RootState) => state.appConfig.cancelUrl);
  const getYodleeConfirmationBody = (confirmationNo: string) => (
    <>
      <div>
        <label className="b-typography-sans-serif--headline--50 b-font-weight-bold">
          Confirmation # {confirmationNo || 'N/A'}
        </label>
      </div>
      <div className="b-padding-block-start--micro--normal">
        <label className="b-typography-sans-serif--body--200">
          Your eligible assets should transfer in kind in{' '}
          <span className="b-font-weight-bold">approximately 7 business days.</span> We’ll
          send you status updates by email.
        </label>
      </div>
    </>
  );

  const getManualConfirmationBody = () => (
    <>
      <div className="b-padding-block-start--micro--normal">
        <label className="b-typography-sans-serif--body--200">
          We will begin processing your transfers. Depending on the external institution,
          transfers may take anywhere from 5 to 30 days to complete. We will contact you
          via phone or email if your transfers require attention.
        </label>
      </div>
      <div className="b-padding-block-start--micro--normal">
        <label className="b-typography-sans-serif--body--200">
          In the meantime, you can monitor your account balances to verify that the
          transfer has completed.
        </label>
      </div>
    </>
  );
  useEffect(() => {
    if (processType === 'YODLEE') {
      dispatchPageLoad('ConfirmationYoureAllSet');
    } else {
      dispatchPageLoad('ConfirmationYouveSignedAndSubmitted');
    }
  }, [processType]);
  return (
    <>
      <section className="layout-section">
        <div className="b-typography-serif--headline--500">
          {processType === 'YODLEE'
            ? 'Thanks for Choosing T. Rowe Price!'
            : ' Transfer submitted successfully'}
        </div>
        <div className="content-container b-grid --b-grid-gap=200">
          <div className="content-left b-grid-item b-xs:12-col b-sm:12-col b-md:8-col b-lg:8-col">
            <div className="confirmation-block b-padding-inline--micro--jumbo">
              <div>
                <label className="b-typography-sans-serif--headline--200 b-font-weight-bold">
                  {processType === 'YODLEE'
                    ? 'You’re all set!'
                    : 'You’ve signed and submitted your transfer documents.'}
                </label>
              </div>
              <div className="b-padding-block-start--micro--normal">
                {processType === 'YODLEE'
                  ? getYodleeConfirmationBody(confirmationNumber ?? '')
                  : getManualConfirmationBody()}
              </div>
            </div>
          </div>
          <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:4-col b-lg:4-col">
            <div className="flow-tracker-container">
              <FlowTracker currentFlowStep={1} items={FlowTrackerConfirmationSteps} />
            </div>
          </div>
        </div>
      </section>
      <div className="docusign-footer">
        <div className="footer-right">
          <ATBeaconButton
            className="button-Next"
            variant={CTAVariants.Primary}
            slot={FooterSlot.Right}
            onClick={() => {
              window.location.assign(cancelUrl);
            }}
          >
            Return to Transactions
          </ATBeaconButton>
        </div>
      </div>
    </>
  );
};

export default DocusignConfirmation;
